import { render, staticRenderFns } from "./PrizeName.vue?vue&type=template&id=050cfe10&"
import script from "./PrizeName.vue?vue&type=script&lang=js&"
export * from "./PrizeName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('050cfe10')) {
      api.createRecord('050cfe10', component.options)
    } else {
      api.reload('050cfe10', component.options)
    }
    module.hot.accept("./PrizeName.vue?vue&type=template&id=050cfe10&", function () {
      api.rerender('050cfe10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prize/pool/components/PrizeName.vue"
export default component.exports